/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ClientBudgetConfirmed {
  Yes = "Yes",
  No = "No",
  NoButPricingShared = "NoButPricingShared",
}

export const ClientBudgetConfirmedDisplay: Record<ClientBudgetConfirmed, string> = {
  [ClientBudgetConfirmed.Yes]: "Yes",
  [ClientBudgetConfirmed.No]: "No",
  [ClientBudgetConfirmed.NoButPricingShared]: "No But Pricing Shared",
};
